// extracted by mini-css-extract-plugin
module.exports = {"controlTextBlocked":"token-area-icon_controlTextBlocked__yUwH5","link":"token-area-icon_link__3rZC5"};